import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HOME_PATH, isOverlayPath } from "../routes";

const HOME_LOCATION = { pathname: HOME_PATH, search: "", hash: "", state: null, key: "home" };

// The browsing page that stays mounted underneath item / cart / search overlays.
export function usePageLocation() {
  const location = useLocation();
  if (!isOverlayPath(location.pathname)) return location;
  return location.state?.background ?? HOME_LOCATION;
}

export default function useOverlay() {
  const location = useLocation();
  const navigate = useNavigate();
  const page = usePageLocation();
  const isOverlay = isOverlayPath(location.pathname);
  const hasBackground = Boolean(location.state?.background);

  // Moving between overlays replaces the entry so closing always returns to the page.
  const open = useCallback(
    (to) => navigate(to, { state: { background: page }, replace: isOverlay }),
    [navigate, page, isOverlay],
  );

  const close = useCallback(() => {
    if (hasBackground) navigate(-1);
    else navigate(HOME_PATH, { replace: true });
  }, [navigate, hasBackground]);

  return { open, close, isOverlay, pathname: location.pathname };
}
